import { Text } from "@mantine/core"

export function UserCell({
  user,
}: {
  user: { firstName: string; lastName: string }
}) {
  return (
    <>
      <Text size="sm">
        {user.firstName} {user.lastName}
      </Text>
    </>
  )
}
